export default {
  
    banco: {
    }
}